<template>
  <div class="promotion_new">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Advert</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /

      <router-link to="/promotion">
        Advert
      </router-link>
      /

      <b>Edit</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div>
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_detail" role="tab"
            aria-controls="_detail" aria-selected="true">Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_log" role="tab" aria-controls="_log"
            aria-selected="false">Logs</a>
        </li>
      </ul>
    </div>

    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active bg-white" id="_detail" role="tabpanel" aria-labelledby="individual-tab">
        <div class="card-body">
          <EditAdvert />
        </div>
      </div>

      <!-- different tabs -->
      <div class="tab-pane fade bg-white" id="_log" role="tabpanel" aria-labelledby="multiple-tab">
        <AdvertLogs />
      </div>
    </div>

  </div>
</template>

<script>
import EditAdvert from './edit.vue';
import AdvertLogs from './logs.vue'

export default {

  name: "advert_edit",
  components: { EditAdvert, AdvertLogs },

  data() {
    return {
    };
  },

  methods: {

  },

  async mounted() {
  }
};
</script>

<style scoped>
.class-flex {
  gap: 20px !important;
}

.child-flex-class {
  gap: 10px !important;
}

.input-flex-class {
  gap: 10px !important;
}
</style>
